import React, { useContext, useEffect, useState } from "react";
import { List } from "@material-ui/core";
import { sidebarMenuList } from "../../services/routes";
import MenuItem from "./MenuItem";
import AuthContext from "../../hooks/authContext";
import { AddNewButton } from "./AddNewButton";
import { useMediaQuery } from "@mui/material";
import SingleSelectNew from "../SelectField/SingleSelectNew";

const SidebarMenu = ({ props, handleDrawerToggle, change }) => {
  const auth = useContext(AuthContext);
  const isExpanded = auth.isExpanded;
  const [selectCompany, setSelectCompany] = useState();
  const isMobile = useMediaQuery("(max-width:767px)");
  const pkgId = auth?.userProfile?.prdId;
  const SubBar = auth?.userProfile?.subscriptionDetails?.status === "trialing" ? true : false;
  const rawRole = auth?.userProfile?.role;
  const employeeRole = auth?.userProfile?.employeerole;

  const role = [
    ...(Array.isArray(rawRole) ? rawRole : rawRole ? [rawRole] : []),
    ...(Array.isArray(rawRole)
        ? rawRole.includes("Employee") && employeeRole ? [employeeRole] : []
        : rawRole === "Employee" && employeeRole ? [employeeRole] : []
    )
  ].filter(Boolean);
  // const allowedPermissions = packageAccess(pkgId);

  // const filteredMenuList = auth?.userProfile?.role !== "superUser" ? sidebarMenuList
  //   .filter(menu => !menu.pkgAccess || allowedPermissions?.routes.includes(menu.pkgAccess))
  //   .map(menu => ({
  //     ...menu,
  //     childItems: menu.childItems?.filter(child => allowedPermissions?.routes.includes(child.pkgAccess)) || [],
  //   })) : sidebarMenuList;
  // const filteredMenuList = SubBar === true ? sidebarMenuList?.map((item) => ({...item, childItems: item?.childItems?.filter((itm) => itm?.to !== "/help/manageSupport"),})) : sidebarMenuList;
  // const filteredMenuList = sidebarMenuList;
  const filteredRoutes = sidebarMenuList
  ?.map(route => {
    const hasAccess = role.some(r => route.roles.includes(r));
    return hasAccess ? route : null;
  })
  ?.filter(Boolean);

const mergedRoutes = filteredRoutes.reduce((acc, curr) => {
  const existing = acc?.find(r => r.label === curr.label && r.to === curr.to);
  if (existing) {
    existing.childItems = [
      ...existing.childItems,
      ...curr.childItems
    ].filter(
      (v, i, a) => a?.findIndex(x => x.to === v.to) === i
    );
  } else {
    acc.push({ ...curr });
  }
  return acc;
}, []);

  const superUser = auth?.userProfile?.role === "superUser";
  const companies = JSON.parse(localStorage.getItem("companies"));
  const clients = JSON.parse(localStorage.getItem("clients"));
  const comapnyId = localStorage.getItem("companyId");

  const options = companies?.map((item) => ({
    value: item?.id,
    label: `${item?.firstName} ${item?.lastName}`,
  }));

  const handleCompanyChange = async (selectedOption) => {
    setSelectCompany(selectedOption);
    const selectedClientData = clients?.find(
      (c) => c?.companyId === selectedOption
    );
    localStorage.setItem("clientId", selectedClientData?.id);
    localStorage.setItem("companyId", selectedOption);
    window?.location?.reload();
  };

  useEffect(() => {
    if (comapnyId) {
      setSelectCompany(comapnyId);
    }
  }, [comapnyId]);

  return (
    <div style={{ marginTop: isMobile ? "55px" : "" }}>
      {!isExpanded && !superUser && auth?.userProfile?.role !== "Client" && (
        <AddNewButton
          collapsed={change}
          handleDrawerToggle={handleDrawerToggle}
        />
      )}
      {auth?.userProfile?.role === "Client" && companies?.length > 1 && (
        <div className="px-3 py-2" style={{ width: isMobile ? "400px" : "240px" }}>
        <SingleSelectNew
          contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
          itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
          placeholder={"Select Company"}
          value={selectCompany}
          options={options}
          onChange={handleCompanyChange}
          zIndex={9999}
        />
        </div>
      )}
      <List
        className={`sidebarMenuWrap ${isExpanded ? "collapsed" : "expanded"}`}
      >
        {mergedRoutes?.map((item, index) => (
          <MenuItem
            key={"menuitemwrap" + index}
            item={item}
            index={index}
            handleDrawerToggle={handleDrawerToggle}
            change={change}
          />
        ))}
      </List>
    </div>
  );
};

export default SidebarMenu;
